import { render, staticRenderFns } from "./_brand.vue?vue&type=template&id=874bbc50&"
import script from "./_brand.vue?vue&type=script&lang=js&"
export * from "./_brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports